import ChooseSlot from '@/components/ChooseSlot';
import RepairForm from '@/components/RepairForm';
import { ServiceRequestContext, serviceReqData } from '@/context/serviceRequestContext';
import { useContext, useEffect, useState } from 'react';
import BookAService from './bookAService';
import RequestTypes from './requestType';
import ServiceRequestSummary from './serviceRequestSummary';
import { ProductContext } from '@/context/productContext';
import { AssetsData } from '@/types/asset';
import { ReinstallForm } from '../../SubComponents/reinstallForm';
import styles from './style.module.scss';
import { AppScreens, WebEngageEventNames } from '@/types/wegengage';
import { WebEngageContext } from '@/context/webengageContext';
import WebEngageUtils from '@/utils/webengageUtils';
import { FullPageLoader } from '../../SubComponents/FullPageLoader';
import Div from '@/shared/Div';
import PaymentSucessScreen from '../../PaymentSuccessScreen';
import useScreen from '@/hooks/useScreen';
import MapLocator from '@/components/LocationDetails/MapLocator';

export type productDataType = {
  productData: AssetsData[];
  showBookServiceCta?: boolean;
};

export type address = {
  house_number: number | string;
  address_name: string;
  address1?: string;
  address2?: string;
  address3?: string;
  address4?: string;
  city: string;
  state: string;
  postal_code: number | string;
  latitude: string;
  longitude: string;
};

export const ServiceRequest = (props: productDataType) => {
  const { productData, showBookServiceCta } = props;
  const { state: serviceState, dispatch: serviceAction } = useContext(ServiceRequestContext);
  const { state: webengageState } = useContext(WebEngageContext);
  const { scriptLoaded } = webengageState;
  const { serviceReqHistoryData } = serviceState;
  const {
    currentComp,
    serviceSlot,
    serviceRequestID,
    isRescheduleFlow,
    defectType,
    serviceType,
    prepaidAmountCollected,
  } = serviceState;
  const { state: productState } = useContext(ProductContext);
  const selProduct = productState?.selectedProduct;
  const address: address = selProduct?.address ? selProduct.address : null;
  const [isLoading, setIsLoading] = useState(false);
  const { isMobile } = useScreen();

  useEffect(() => {
    const scrollElement = document.querySelector<HTMLElement>(`[class*='${styles.withBorder}']`);
    const noScrollElement = document.querySelector<HTMLElement>(
      `[class*='${styles.withoutBorder}']`,
    );
    if (scrollElement && noScrollElement) {
      window.onscroll = () => {
        if (window.scrollY > 20) {
          scrollElement.style.display = 'block';
          noScrollElement.style.display = 'none';
        } else {
          scrollElement.style.display = 'none';
          noScrollElement.style.display = 'flex';
        }
      };
    }
  });

  useEffect(() => {
    const _we = window.webengage;
    if (_we) {
      let _mandatoryReq = false;
      if (serviceReqHistoryData?.openRequests?.length > 0) {
        _mandatoryReq =
          serviceReqHistoryData?.openRequests.find((el: serviceReqData) => {
            const { serviceType } = el;
            return serviceType === 'MS';
          })?.serviceType === 'MS';
      }
      const _service_request_open = WebEngageUtils.returnBoolString(
        serviceReqHistoryData?.openRequests?.length > 0,
      );
      const _mandatory_service_open = WebEngageUtils.returnBoolString(_mandatoryReq);
      serviceAction.initWebengageContext({
        service_request_open: _service_request_open,
        mandatory_service_open: _mandatory_service_open,
      });

      _we.track(WebEngageEventNames.SERVICE_BOOKING_SCREEN_OPENED, {
        ...webengageState.webengageDefault,
        navigated_from: AppScreens.SERVICE_BOOKING_SCREEN,
        customer_type: WebEngageUtils.stringUtil(selProduct?.expiryStatus?.status),
        mandatory_service_open: _mandatory_service_open,
        service_request_open: _service_request_open,
      });
    }
  }, [scriptLoaded]);

  function renderComponent() {
    switch (currentComp.component) {
      case 'pendingRequest':
        return (
          <BookAService
            productData={productData}
            serviceReqHistoryData={serviceReqHistoryData}
            showBookServiceCta={showBookServiceCta}
          />
        );
      case 'bookAService':
        return <RequestTypes />;
      case 'selectRepair':
        return <RepairForm />;
      case 'reInstallForm':
        return <ReinstallForm defaultAddress={address} />;
      case 'bookASlot':
        return <ChooseSlot />;
      case 'serviceReqSummary':
        return <ServiceRequestSummary defaultAddress={address} productsData={productData} />;
      case 'bookServiceSuccess': {
        const { address, name, planType, id, expiryStatus } = selProduct;
        return (
          <PaymentSucessScreen
            title={isMobile ? 'Service request \n received' : 'Service request received'}
            serviceStartTime={serviceSlot?.slot.startTime}
            serviceEndTime={serviceSlot?.slot?.endTime}
            city={address.city}
            deviceName={name}
            status={expiryStatus?.status}
            serviceType={serviceType}
            defectType={defectType}
            tier={planType}
            deviceId={id}
            serviceRequestID={serviceRequestID}
            isRental={selProduct.isRental}
            prepaidAmountCollected={prepaidAmountCollected}
            onlyServiceFlow
            isRescheduleFlow
          />
        );
      }
      case 'mapLocator':
        return <MapLocator />;
    }
  }

  return (
    <>
      <Div>{renderComponent()}</Div>
      <FullPageLoader isLoading={isLoading} />
    </>
  );
};
